import { render, staticRenderFns } from "./PorletTableElement.vue?vue&type=template&id=51b245c0&"
import script from "./PorletTableElement.vue?vue&type=script&lang=js&"
export * from "./PorletTableElement.vue?vue&type=script&lang=js&"
import style0 from "./PorletTableElement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports